export default class Validation {
	constructor(
		public pass: boolean,
		public errorString: string
	) {

	}
	
}